    <div class="container py-2">
        <hr>
        <span class="small">  <i class="fa fa-copyright" aria-hidden="true"></i>
            {{currentYear}} - Chicago Public Schools | {{serverName$ | async}}
          </span>
    </div>

  